import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const CardContainer = styled(Box)`
    background-color: #373435;
`;
